import React from "react";

function BracketVideo({ division }) {
 if (!division?.video_url) return null;

 return (
  <div
   style={{
    width: 420,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#fff",
   }}
  >
   <h3 style={{ marginBottom: 8 }}>Tournament Highlights</h3>

   <div
    style={{
     position: "relative",
     width: "100%",
     paddingBottom: "56.25%", // 16:9
     borderRadius: 10,
     overflow: "hidden",
     boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    }}
   >
    <iframe
     src={division.video_url.replace("watch?v=", "embed/")}
     title="Tournament Video"
     frameBorder="0"
     allowFullScreen
     style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
     }}
    />
   </div>
  </div>
 );
}

export default BracketVideo;
